import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoSelect
} from 'packages';
import {
  INCIDENT_SEVERITY_OPTIONS,
  INCIDENT_STATUS_OPTIONS,
  ENVIRONMENT_OPTIONS
} from '../../constants';

function IncidentCrud({ form, handleFinish, services = [], releases = [], isEditing = false }) {
  const SeverityWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select severity' options={INCIDENT_SEVERITY_OPTIONS} />
  );

  const StatusWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select status' options={INCIDENT_STATUS_OPTIONS} />
  );

  const ServiceWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select service' options={services} allowClear />
  );

  const EnvironmentWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Environment' options={ENVIRONMENT_OPTIONS} />
  );

  const ReleaseWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Link release' options={releases} allowClear />
  );

  const fields = [
    { key: 'title', label: 'Incident Title', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'e.g. Auth service 5xx spike' } },
    { key: 'severity', label: 'Severity', colSpan: 1, widget: SeverityWidget, forwardRef: true, required: true },
    { key: 'status', label: 'Status', colSpan: 1, widget: StatusWidget, forwardRef: true },
    { key: 'service', label: 'Service', colSpan: 2, widget: ServiceWidget, forwardRef: true },
    { key: 'owner', label: 'Owner', colSpan: 2, widget: KoInput, widgetProps: { placeholder: 'Incident owner' } },
    { key: 'linkedRelease', label: 'Linked Release', colSpan: 2, widget: ReleaseWidget, forwardRef: true },
    { key: 'environment', label: 'Environment', colSpan: 2, widget: EnvironmentWidget, forwardRef: true },
    { key: 'description', label: 'What Happened?', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 3, placeholder: 'Describe the incident...' } }
  ];

  if (isEditing) {
    fields.push(
      { key: 'rootCause', label: 'Root Cause', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 2, placeholder: 'Root cause analysis...' } },
      { key: 'resolutionNotes', label: 'Resolution Notes', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 2, placeholder: 'How it was resolved...' } }
    );
  }

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={meta} />
    </KoForm>
  );
}

export default IncidentCrud;
